"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../type/entity");
function getEnrolmentContentType(content) {
    const modelType = content.modelType;
    switch (modelType) {
        case 'offer':
            return entity_1.EnrolmentContentType.OFFER;
        case 'curriculumOffer':
            return entity_1.EnrolmentContentType.CURRICULUM_OFFER;
        case 'activity':
            switch (content.activityType) {
                case 'skill':
                    return entity_1.EnrolmentContentType.SKILL;
                case 'checkpoint':
                    return entity_1.EnrolmentContentType.CHECKPOINT;
                case 'liveTraining':
                    return entity_1.EnrolmentContentType.ILT;
                default:
                    throw new Error('Invalid activityType  ' + content.activityType);
            }
        default:
            throw new Error('Invalid modelType ' + modelType);
    }
}
exports.getEnrolmentContentType = getEnrolmentContentType;
//# sourceMappingURL=getEnrolmentContentType.js.map